import React, { useMemo, useRef, useState } from "react";
import {
  useFloating,
  useInteractions,
  useHover,
  useFocus,
  offset,
  flip,
  shift,
  arrow
} from "@floating-ui/react";
 
const FloatingTooltip = ({ delay, children, content }) => {
  const [open, setOpen] = useState(false);
  const arrowRef = useRef(null);

  const { x, y, strategy, refs, context } = useFloating({
    open,
    onOpenChange: setOpen,
    middleware: [offset(10), flip(), shift(), arrow({ element: arrowRef })],
    arrowRef
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([
    useHover(context, {
      delay: {
        open: 300 || delay,
        close: 0,
      },
    }),
    useFocus(context)
  ]);

  useMemo(() => ({
      open,
      setOpen,
      arrowRef
  }),[open, setOpen, arrowRef]);

  const { x: arrowX, y: arrowY } = context.middlewareData.arrow ? context.middlewareData.arrow : {};

  const staticSide = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  };

  const arrowSide = useMemo(() => {
    return staticSide[context.placement.split("-")[0]] || '';
  }, [context]);

  return (
    <>
      <div ref={refs.setReference} {...getReferenceProps()}>
        {children}
      </div>
      {open && (
        <div
          ref={refs.setFloating}
          style={{
            position: strategy,
            left: x ? x : 0,
            top: y ? y : 0,
            background: "black",
            color: "white",
            padding: 8,
            fontSize: 12,
            borderRadius: '4px',
            zIndex: 1,
            opacity: 0.8
          }}
          {...getFloatingProps()}
        >
         {content}
         <div
            ref={arrowRef}
            style={{
              position: "absolute",
              width: "10px",
              height: "10px",
              background: "inherit",
              left: arrowX ? `${arrowX}px` : "",
              top: arrowY ? `${arrowY}px` : "",
              [arrowSide]: "-5px",
              transform: "rotate(45deg)"
            }}
          />
        </div>
      )}
    </>
  );
};

export default FloatingTooltip;
